import React, {useState} from "react";
import {Dialog, IconButton} from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import generalImage from '../../shared/images/_TireSize_PopUp.jpg'
import buickImage from '../../shared/images/_buickTireSize_PopUp.jpg'
import gmcImage from '../../shared/images/_gmcTireSize_PopUp.jpg'
import chevyImage from '../../shared/images/_chevyTireSize_PopUp.jpg'
import cadillacImage from '../../shared/images/_cadillacTireSize_PopUp.jpg'
import {HOWTO} from "../../shared/constantsEN";
import {useSelector} from "react-redux";

export default function HelpModal() {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const brand = useSelector(state => state.appParamsReducer.brand);

    let image;

    switch (brand){
        case 'buick':
            image = buickImage;
            break;
        case 'cadillac':
            image = cadillacImage;
            break;
        case 'chevy':
            image = chevyImage;
            break;
        case 'gmc':
            image = gmcImage;
            break;
        default:
            image = generalImage;
    }

    return (
        <div className={"helpText"}> {HOWTO}
            <IconButton className={'helpButton stat-button-link'} data-dtm="vehicle info"
                        aria-label={"How to find your tire size"} onClick={handleOpen}>
                <HelpOutlineIcon/>
            </IconButton>

            <Dialog
                aria-labelledby="How to find tire size"
                aria-describedby="How to find tire size"
                open={open}
                onClose={handleClose}
            >
                <div className={'modal-header'}>
                    <div className="header-close" onClick={handleClose}>
                        <div className="header-close-icon icon close" />
                    </div>
                </div>
                <div>
                    <img className={'helpImage'} src = {image} alt = 'How to find tire size'/>
                </div>
            </Dialog>
        </div>
    );
}
